import React from "react"
import * as R from "ramda"
import { Link } from "gatsby"
import { useMicroCopyFi } from "../hooks/microCopy"
import GetMicroCopy from "../shared/getMicroCopy"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction"
import IconButton from "@material-ui/core/IconButton"
import Box from "@material-ui/core/Box"
import ArrowRightAltIcon from "@material-ui/icons/ArrowForward"
import CallMadeIcon from "@material-ui/icons/CallMade"

const BasicPageLinkList = ({ pageContent }) => {
  const microCopyTexts = useMicroCopyFi
  const labelQuickLinks = GetMicroCopy(microCopyTexts, "yleinenPikalinkit")
  const links = R.path(["links"], pageContent)

  return (
    <Box>
      <h3>{labelQuickLinks}</h3>
      <List dense={true}>
        {links &&
          links.map(item => (
            <ListItem>
              <a
                className="black"
                rel="noreferrer"
                target="_blank"
                href={item.url}
              >
                {item.urlText}
              </a>
              <ListItemSecondaryAction>
                <IconButton edge="end">
                  <ArrowRightAltIcon />
                </IconButton>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
      </List>
    </Box>
  )
}

export default BasicPageLinkList
